import {
  african,
  american,
  british,
  cajun,
  caribbean,
  chinese,
  eastern_european,
  french,
  german,
  greek,
  indian,
  irish,
  italian,
  japanese,
  jewish,
  korean,
  latin_american,
  mediterranean,
  mexican,
  middle_eastern,
  nordic,
  southern,
  spanish,
  thai,
  vietnamese,
  european,
} from "../assets/images";

export const cuisine_data = [
  { name: "African", image: african },
  { name: "American", image: american },
  { name: "British", image: british },
  { name: "Cajun", image: cajun },
  { name: "Caribbean", image: caribbean },
  { name: "Chinese", image: chinese },
  { name: "Eastern European", image: eastern_european },
  { name: "European", image: european },
  { name: "French", image: french },
  { name: "German", image: german },
  { name: "Greek", image: greek },
  { name: "Indian", image: indian },
  { name: "Irish", image: irish },
  { name: "Italian", image: italian },
  { name: "Japanese", image: japanese },
  { name: "Jewish", image: jewish },
  { name: "Korean", image: korean },
  { name: "Latin American", image: latin_american },
  { name: "Mediterranean", image: mediterranean },
  { name: "Mexican", image: mexican },
  { name: "Middle Eastern", image: middle_eastern },
  { name: "Nordic", image: nordic },
  { name: "Southern", image: southern },
  { name: "Spanish", image: spanish },
  { name: "Thai", image: thai },
  { name: "Vietnamese", image: vietnamese },
];

export const cuisine_list = [
  null,
  "African",
  "American",
  "British",
  "Cajun",
  "Caribbean",
  "Chinese",
  "Eastern European",
  "European",
  "French",
  "German",
  "Greek",
  "Indian",
  "Irish",
  "Italian",
  "Japanese",
  "Jewish",
  "Korean",
  "Latin American",
  "Mediterranean",
  "Mexican",
  "Middle Eastern",
  "Nordic",
  "Southern",
  "Spanish",
  "Thai",
  "Vietnamese",
];

export const meal_type = [
  null,
  "main course",
  "side dish",
  "dessert",
  "appetizer",
  "salad",
  "bread",
  "breakfast",
  "soup",
  "beverage",
  "sauce",
  "marinade",
  "fingerfood",
  "snack",
  "drink",
];

export const intolerances_list = [
  null,
  "Dairy",
  "Egg",
  "Gluten",
  "Grain",
  "Peanut",
  "Seafood",
  "Sesame",
  "Shellfish",
  "Soy",
  "Sulfite",
  "Tree Nut",
  "Wheat",
];

export const diet_list = [
  null,
  "Gluten Free",
  "Ketogenic",
  "Vegetarian",
  "Lacto-Vegetarian",
  "Ovo-Vegetarian",
  "Vegan",
  "Pescetarian",
  "Paleo",
  "Primal",
  "Low FODMAP",
  "Whole30",
];
